import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice surface du réservoir - Calcul de la surface selon les dimensions";
const DESCRIPTION =
  "Calculatrice surface du réservoir - Calcul de la surface selon les dimensions pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "surface du réservoir calcul de la surface selon les dimensions, calculatrice surface du réservoir calcul de la surface selon les dimensions, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/tank-area";
function TankArea() {
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [totalArea, setTotalArea] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    if (!length || !width || !height) {
      setError("Veuillez entrer les dimensions correctement");
      setTotalArea("");
      return;
    }
    const lengthValue = parseFloat(length);
    const widthValue = parseFloat(width);
    const heightValue = parseFloat(height);
    if (
      isNaN(lengthValue) ||
      isNaN(widthValue) ||
      isNaN(heightValue) ||
      lengthValue <= 0 ||
      widthValue <= 0 ||
      heightValue <= 0
    ) {
      setError("Veuillez entrer des valeurs valides et positives pour les dimensions");
      setTotalArea("");
      return;
    }
    const surfaceArea =
      2 *
      (lengthValue * widthValue +
        lengthValue * heightValue +
        widthValue * heightValue);
    setTotalArea(surfaceArea.toFixed(2));
    setError("");
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Comment calculer la surface d'un réservoir</h2>
                <p>
                  Un réservoir est un solide composé de 6 rectangles ou carrés.
                  La surface du réservoir se calcule à partir de ses dimensions.
                </p>
                <p>
                  Surface du réservoir = 2 × (longueur × largeur + longueur × hauteur + largeur × hauteur)
                </p>
                <p>
                  Utilisez cette calculatrice pour obtenir la surface du réservoir
                  à partir des dimensions saisies.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label me-2">Longueur (m)</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Longueur"
                      value={length}
                      onChange={(e) => setLength(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label me-2">Largeur (m)</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Largeur"
                      value={width}
                      onChange={(e) => setWidth(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label me-2">Hauteur (m)</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Hauteur"
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculate}
                  >
                    Calculer la surface
                  </button>
                </div>
                <br />
                <div>
                  {error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      Erreur : {error}
                    </p>
                  ) : (
                    <>
                      {totalArea !== "" && (
                        <>
                          <p className="p-3 mb-2 bg-success text-white">
                            Surface du réservoir (m²) : {totalArea}
                          </p>
                          <p className="p-3 mb-2 bg-info text-black">
                            Étapes de résolution : <br />
                            - Calculez la surface de chacun des 6 rectangles.<br />
                            - Additionnez les surfaces des 6 rectangles pour obtenir la surface totale du réservoir.
                          </p>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default TankArea;
